import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint, zIndex } from '@twisto/styles';

export const container = (theme: Theme) => css`
  position: fixed;
  overflow: auto;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: ${zIndex.modal};
  padding: ${theme.spacing[12]};
  pointer-events: auto;

  /* fixes the issue with overflowing slide animation */
  max-width: 100vw;
  overflow-x: hidden;

  ${breakpoint.up('sm')} {
    padding: ${theme.spacing[16]};
  }
`;

export const centered = css`
  display: grid;
  align-items: center;
`;

export const overlay = (theme: Theme) =>
  theme.mode === 'light'
    ? css`
        background: ${theme.palette.overlay.accent};
      `
    : css`
        background: ${theme.palette.deepGrey[200]};
      `;
